import { CookiePolicyLinks, PrivacyPolicyLinks, TermsLinks } from 'constants/staticLinks'

import { LanguageCode } from 'translations/Language'

export const getTermsLink = (language: string) => {
  switch (language) {
    case LanguageCode.EN:
      return TermsLinks.EN
    case LanguageCode.FR:
      return TermsLinks.FR
    case LanguageCode.DE:
      return TermsLinks.DE
    case LanguageCode.ES:
      return TermsLinks.ES
    case LanguageCode.NL:
      return TermsLinks.NL
    default:
      return TermsLinks.ALL_PURPOSE
  }
}

export const getPrivacyPolicyLink = (language: string) => {
  switch (language) {
    case LanguageCode.EN:
      return PrivacyPolicyLinks.EN
    case LanguageCode.FR:
      return PrivacyPolicyLinks.FR
    case LanguageCode.DE:
      return PrivacyPolicyLinks.DE
    case LanguageCode.ES:
      return PrivacyPolicyLinks.ES
    case LanguageCode.NL:
      return PrivacyPolicyLinks.NL
    default:
      return PrivacyPolicyLinks.ALL_PURPOSE
  }
}

export const getCookiePolicyLink = (language: string) => {
  switch (language) {
    case LanguageCode.EN:
      return CookiePolicyLinks.EN
    case LanguageCode.FR:
      return CookiePolicyLinks.FR
    case LanguageCode.DE:
      return CookiePolicyLinks.DE
    case LanguageCode.ES:
      return CookiePolicyLinks.ES
    case LanguageCode.NL:
      return CookiePolicyLinks.NL
    default:
      return CookiePolicyLinks.ALL_PURPOSE
  }
}
